<template>
  <v-sheet class="fill-height" tile color="#ffffff">
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="title">Current Spots</v-col>
        <v-col v-for="item in activeReservations" cols="12" lg="4" xs="12" sm="6" md="6" :key="item.reservation.id">
          <StoreTile mode="reservation" :reservation=item.reservation :store="item.store"></StoreTile>
        </v-col>
        <v-col cols="12" v-if="activeReservations.length == 0" align="center">
          No Active Spots
        </v-col>
      </v-row>
      <br/>
      <br/>
      <v-row>
        <v-col cols="12" class="title">Past Spots</v-col>
        <v-col v-for="item in finishedReservations" cols="12" lg="4" xs="12" sm="6" md="6" :key="item.reservation.id">
          <StoreTile mode="reservation" :reservation=item.reservation :store="item.store"></StoreTile>
        </v-col>
        <v-col cols="12" v-if="finishedReservations.length == 0" align="center">
          No Finished Reservations
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>


<script>
  import {mapGetters} from "vuex";
  import StoreTile from "../Stores/StoreTile";
  import {RESERVATION_STATUS, determineStatusValue} from "../utils/constants";

  const moment = require('moment-timezone')

  export default {
    name: "ReservationsList",
    components: {StoreTile},
    mounted: function () {
      this.$store.dispatch('reloadReservations')
    },
    computed: {
      ...mapGetters(['allReservationsByThisUser', 'getStoreById']),
      allConvertedReservations() {
        var result = []
        var sortedRes = this.allReservationsByThisUser.sort((a, b) => moment.unix(a.dt) < moment.unix(b.dt) ? 1 : -1)
        for (var reservation of this.allReservationsByThisUser) {
          var store = this.getStoreById(reservation.store_id)
          if (store) {
            result.push({'store': store, 'reservation': reservation})
          }
        }
        return result
      },
      activeReservations() {
        let active_reservations = this.allConvertedReservations.filter((item) => determineStatusValue(item.reservation, item.store) == RESERVATION_STATUS.ACTIVE)
        let sorted_reservation = active_reservations.sort(function (a, b) {
          return a.reservation.dt - b.reservation.dt;
        });
        return sorted_reservation
      },
      finishedReservations() {
        return this.allConvertedReservations.filter((item) => determineStatusValue(item.reservation, item.store) != RESERVATION_STATUS.ACTIVE)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/Reservations/ReservationsList.vue